/* eslint-disable max-statements */
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { MultiSelect } from 'primereact/multiselect';
import { Divider } from 'primereact/divider';
import { Calendar } from 'primereact/calendar';

import { selectCurrentEmpid, selectCurrentUserManagerLevel, selectIsPseudoSupervisor } from '../../../pages/login/authSlice';
import { SearchedEmployeType } from '../revGen/type';
import { GetTeamOptions, exportExcel, getRole } from './shoutOutView-service';

import CoachingShoutOut from '../../../components/coachingShoutOut/coachingShoutOUt';
import { useGetShoutOutCarouselQuery } from '../toDoView/toDoViewSlice';
import { useGetShoutOutViewQuery } from './shoutOutViewSlice';
import { ShoutOutCarousel } from '../toDoView/shoutOutCarousel/ShoutOutCarousel';
import { DateTemplate } from '../../../components/dateTemplate/DateTemplate';
import { CoachingEntityTypes } from '../../../utils/typeConstants';
import { EmployeeSearchPopUp } from '../employeeSearchPopUp/EmployeeSearchPopUp';

export const ShoutOutView = () => {
    const loggedUser = useSelector(selectCurrentEmpid);
    const [teamOptions, setTeamOptions] = useState<any>([]);
    const [selectedTeamOption, setSelectedTeamOption] = useState<string>('');
    const userMngrRole = useSelector(selectCurrentUserManagerLevel);
    const isPseudoSupervisor = useSelector(selectIsPseudoSupervisor);
    const [empNo, setEmpNo] = useState<string>(loggedUser);
    const [globalFilterValue, setGlobalFilterValue] = useState<any>('');
    const [filters, setFilters] = useState<any>({});
    const [entity, setEntity] = useState<any>([]);
    const [showShoutOutDialog, setShowShoutOutDialog] = useState<boolean>(false);
    const [shoutOutViewOnly, setShoutOutViewOnly] = useState<boolean>(false);
    const [selectedShoutOut, setSelectedShoutOut] = useState<any>(null);
    const [searchVisible, setSearchVisible] = useState<boolean>(false);
    const [shoutOutData, setShoutOutData] = useState<any>([]);
    const [searchedEmployee, setSearchedEmployee] = useState<SearchedEmployeType>({
        'employee_name': '',
        'employee_number': '',
        'location': '',
        'job_title': '',
    });

    const teamSelected = () => {
        if (selectedTeamOption === 'myActivity') return 'myshoutouts'
        if (selectedTeamOption === 'myTeamActivity') return 'myteamshoutouts'
        if (selectedTeamOption === 'mycreatedshoutouts') return 'mycreatedshoutouts'
        if (selectedTeamOption === 'search') return selectedTeamOption
        return null
    }
    const { data: coachingShoutOutView } = useGetShoutOutViewQuery(
        {
            employeeNumber: loggedUser,
            searchOracleId: empNo,
            teamOption: teamSelected(),
        },
        {
            skip:
                !selectedTeamOption ||
                !loggedUser
        }
    );
    const { data: shoutOuts } = useGetShoutOutCarouselQuery({
        employeeNumber: loggedUser,
        employeeRole: getRole(userMngrRole, isPseudoSupervisor),
    });
    const initFilters = () => {
        /* eslint-disable camelcase */
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            start_date: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
            },
            recipient: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
            },
            author: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
            },
            shout_out_title: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
            },
            coaching_to_do_status_name: { value: null, matchMode: FilterMatchMode.IN },
            end_date: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
            },
            coaching_entity_type_name: { value: null, matchMode: FilterMatchMode.IN },
        });
        setGlobalFilterValue('');
        /* eslint-enable camelcase */
    };
    const clearFilter = () => {
        initFilters();
    };
    useEffect(() => {
        initFilters();
    }, []);
    useEffect(() => {
        const data: any = coachingShoutOutView?.data.map((element: any) => {
            return {
                ...element,
                'start_date': element.start_date ? new Date(element.start_date) : null,
                'end_date': element.end_date ? new Date(element.end_date) : null,
            };
        });
        setShoutOutData(data);
    }, [coachingShoutOutView]);
    useEffect(() => {
        const distEntity = Array.from(
            new Set(shoutOutData?.map((item: any) => item.coaching_entity_type_name))
        );
        setEntity(distEntity);
    }, [shoutOutData, setEntity]);

    useEffect(() => {
        setTeamOptions(GetTeamOptions());
    }, [loggedUser]);
    useEffect(() => {
        const selectedTeam = localStorage.getItem('selectedTeam');
        if (selectedTeam && teamOptions.some((item: any) => item.code === selectedTeam)) {
            setSelectedTeamOption(selectedTeam);
        } else {
            setSelectedTeamOption('myActivity')
        }
    }, [teamOptions]);
    useEffect(() => {

        const searchedUserString: string | null = localStorage.getItem('searchedUser');
        if (selectedTeamOption === 'search') {
            if (searchedUserString) {
                const searchedUser: SearchedEmployeType = JSON.parse(searchedUserString);
                setSearchVisible(false);
                setSearchedEmployee(searchedUser);
                setEmpNo(searchedUser?.employee_number);
            } else {
                setSearchVisible(true);
                setEmpNo(loggedUser);
            }
        }
    }, [selectedTeamOption]);
    useEffect(() => {
        if (searchedEmployee?.employee_number && selectedTeamOption === 'search') {
            setEmpNo(searchedEmployee?.employee_number);
        }
    }, [searchedEmployee])
    const onGlobalFilterChange = (e: any) => {
        const value = e.target.value;
        const afilters = { ...filters };
        // @ts-ignore
        afilters.global.value = value;
        setFilters(afilters);
        setGlobalFilterValue(value);
    };
    const entityFilterTemplate = (options: any) => {
        return (
            <MultiSelect
                value={options.value}
                options={entity}
                onChange={(e: any) => options.filterApplyCallback(e.value)}
                placeholder="Any"
                className="p-column-filter"
            />
        );
    };
    const renderHeader = () => {
        return (
            <>
                <Divider />
                <div className="d-flex justify-content-between" style={{ textAlign: 'left' }}>
                    <div className="d-flex justify-content-start">
                        <Button type="button" icon="pi pi-filter-slash" className='btn-primary btn-sm' label="Clear" onClick={clearFilter} />
                        <span className="p-input-icon-left ms-3">
                            <i className="pi pi-search" />
                            <InputText
                                value={globalFilterValue}
                                onChange={onGlobalFilterChange}
                                placeholder="Keyword Search"
                            />
                        </span>
                    </div>

                    <div className="d-flex justify-content-end">
                        <Button
                            label="Add Shout Out"
                            icon="pi pi-plus-circle"
                            className="btn-primary me-2"
                            onClick={() => { setShowShoutOutDialog(true); setShoutOutViewOnly(false); setSelectedShoutOut(null) }}
                            aria-controls="popup_menu_left"
                            aria-haspopup
                        />
                        <Button
                            type="button"
                            icon="pi pi-upload me-2"
                            className="btn-export"
                            onClick={() => {
                                exportExcel(shoutOutData);
                            }}
                            data-pr-tooltip="XLS"
                            disabled={shoutOutData?.length === 0}
                        >
                            Export All
                        </Button>
                    </div>
                </div>
            </>
        );
    };
    const header = renderHeader();
    const onShoutOutClick = (event: any) => {
        if (event.field === 'shout_out_title') {
            setShoutOutViewOnly(true);
            const SeletedRow: any = {
                employeeNumber: event?.rowData?.recipient_id,
                title: event?.rowData?.shout_out_title,
                description: event?.rowData?.shout_out_description,
                startDate: DateTemplate(event?.rowData?.start_date),
                endDate: DateTemplate(event?.rowData?.end_date)
            };
            setSelectedShoutOut(SeletedRow);
            setShowShoutOutDialog(true);
        }
    };
    const dateOnchanges = (e: any, options: any) => {
        options.filterCallback(e.value, options.index);
    };
    const dateFilterTemplate = (options: any) => {
        return (
            <Calendar
                value={options.value}
                onChange={(e: any) => dateOnchanges(e, options)}
                dateFormat="mm/dd/yy"
                placeholder="dd/mm/yy"
                mask="99/99/9999"
                showIcon
                className="custom-calendar"
            />
        );
    };
    return (
        <div className="card mt-3 ms-0 me-0 shadow bg-body rounded border-0">
            <div className='float-left' style={{ marginTop: '10px', marginLeft: '16px' }}>
                <h5>Shout Outs</h5>
            </div>
            <div className="row d-flex mt-4 ms-2 me-2">
                {getRole(userMngrRole, isPseudoSupervisor) !== 'associate' && (
                    <div className="col-md-2" style={{ paddingBottom: '2rem' }}>
                        <h6 style={{ fontWeight: '600', fontSize: '16px' }}>Select Team</h6>
                        <Dropdown
                            value={selectedTeamOption}
                            onChange={(event) => {
                                localStorage.removeItem('searchedUser');
                                localStorage.setItem('selectedTeam', event.target.value);
                                setSelectedTeamOption(event.target.value);
                            }}
                            options={teamOptions}
                            optionLabel={'name'}
                            optionValue={'code'}
                            placeholder="Select Team"
                            className="custom-dropdown"
                            disabled={getRole(userMngrRole, isPseudoSupervisor) === 'associate'}
                        />
                    </div>
                )} <div className="col-md-2">
                    {selectedTeamOption === 'search' && (

                        <Button
                            label="Reset"
                            // style={{ fontWeight: 400, marginTop: '30px' }}
                            className="btn-secondary mt-4 mb-2"
                            onClick={() => { setSelectedTeamOption(''); setEmpNo(loggedUser); setShoutOutData([]); }}
                        />

                    )} </div>
                <div className="col-md-8 mt-0 mb-3">
                    <ShoutOutCarousel shoutOuts={shoutOuts?.data || []} />
                </div>
            </div>
            <div>
                <DataTable
                    value={shoutOutData || []}
                    header={header}
                    dataKey="coaching_to_do_id"
                    className="shoutOutViewTable"
                    scrollable
                    scrollHeight="600px"
                    globalFilterFields={[
                        'start_date',
                        'recipient',
                        'author',
                        'shout_out_title',
                        'end_date',
                        'coaching_entity_type_name',
                    ]}
                    filters={filters}
                    rows={5}
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    paginator={shoutOutData?.length > 5}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    onCellClick={onShoutOutClick}
                    cellSelection
                    selectionMode="single"
                >
                    <Column field="start_date" header="Date" sortable filter filterPlaceholder="Search by date"
                        dataType="date"
                        filterElement={dateFilterTemplate} sortField="start_date"
                        body={(date) => DateTemplate(date?.start_date)} />
                    <Column
                        field="recipient"
                        header="Recipient"
                        sortable
                        sortField="recipient"
                        filter
                        filterPlaceholder="Search by Recipient"
                    />
                    <Column
                        field="author"
                        header="Author"
                        sortable
                        sortField="author"
                        filter
                        filterPlaceholder="Search by Author"
                    />
                    <Column
                        field="shout_out_title"
                        header="Title"
                        sortable
                        sortField="shout_out_title"
                        filter
                        filterPlaceholder="Search by Title"
                        bodyStyle={{ minWidth: '15rem', color: '#007bff', textDecoration: 'underline' }}
                    />
                    <Column
                        field="end_date"
                        header="Target Completion Date"
                        sortable
                        sortField="end_date"
                        dataType="date"
                        body={(date) => DateTemplate(date?.end_date)}
                        filter
                        filterPlaceholder="Search by date"
                        filterElement={dateFilterTemplate}
                    />
                    <Column
                        field="coaching_entity_type_name"
                        header="Source"
                        sortable
                        sortField="coaching_entity_type_name"
                        filterField="coaching_entity_type_name"
                        showFilterMatchModes={false}
                        filter
                        filterElement={entityFilterTemplate}
                    />
                </DataTable>
            </div>
            {showShoutOutDialog && (
                <CoachingShoutOut
                    visible={showShoutOutDialog}
                    setVisible={setShowShoutOutDialog}
                    coachingEntityTypeId={CoachingEntityTypes.General}
                    coachingEntityId={0}
                    coreValueId={0}
                    viewOnly={shoutOutViewOnly}
                    selectedShoutOutViewData={selectedShoutOut}
                    receiverId={selectedShoutOut?.employeeNumber ? selectedShoutOut?.employeeNumber : ''}
                />
            )}
            {searchVisible && (
                <EmployeeSearchPopUp
                    visible={searchVisible}
                    searchedEmployee={searchedEmployee}
                    setVisible={setSearchVisible}
                    setSelectedTeam={setSelectedTeamOption}
                    setSearchedEmployee={setSearchedEmployee}
                />
            )}
        </div>
    );
};
